import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import _ from 'lodash';

import { portfolioDomain } from '../../domain';

import PropTypes from 'prop-types';

import RoomTypeHeader from './room-type-header/room-type-header.component';

import MediaGallery from '../media-gallery/media-gallery.component';
import MediaGalleryMobile from '../media-gallery/media-gallery-mobile.component';

import RoomTypeDescription from './room-type-description/room-type-description.component';

import RoomTypeAmenities from './room-type-amenities/room-type-amenities.component';

import RoomTypeVideoTour from './room-type-video-tour/room-type-video-tour.component';

import RoomTypeFloorPlan from './room-type-floor-plan/room-type-floor-plan.component';

import RoomTypeLocation from './room-type-location/room-type-location.component';

import RoomTypeReviews from './room-type-reviews/room-type-reviews.component';

import RoomTypeBuildingAmenities from './room-type-building-amenities/room-type-building-amenities.component';

import RoomTypePortfolio from './room-type-portfolio/room-type-portfolio.component';

import RoomTypeQuote from './room-type-quote/room-type-quote.component';

import RoomTypeAgent from './room-type-agent/room-type-agent.component';

import RoomTypeAboutBuilding from './room-type-about-building/room-type-about-building.component';

import useResponsive from '../../../utils/responsive';

import LazyFeaturedSpaces from '../featured-spaces/lazy-featured-spaces.component';

import LeadGenRequestCallBackForm from '../get-in-touch-components/lead-gen-request-call-back-form.component';

import { useCityById } from '../../domain/city/city.domain';

import { agentDomain, marketingDomain } from '../../domain'

const RoomTypeDetails = (props) => {

    const router = useRouter();

    const { selectedRoomType, cities, buildings, roomContentCMS, peachRedirect, selectedBuilding } = props;

    const { isMobile, isTablet } = useResponsive();

    const portfolioId = _.get(selectedRoomType, 'portfolioId');

    const roomImages = _.get(selectedRoomType, 'images');

    const noRates = _.get(selectedRoomType, 'noRates');

    const cityId = _.get(selectedRoomType, 'buildingAddress.cityId');

    const agentId = _.get(selectedRoomType, 'agentId');

    const [selectedRoomPortfolio, setRoomPortfolio] = useState(null);

    const [agentDetails, setAgentDetails] = useState(null);

    const [isHOMii, setIsHOMii] = useState(false);

    const { data: selectedCity } = useCityById(cityId);  

    useEffect(() => {
        const { referrer } = router.query;
        if (referrer) {
            const submit = async () => {
                await marketingDomain.submitWebsiteVisited(referrer);
            }
            submit();
        }
    },[])

    useEffect(() => { 
        if(!portfolioId) return;
        const search = async () => {
            const fetchedPortofolio = await portfolioDomain.fetchSelectedRoomPortfolioById(portfolioId);
            setRoomPortfolio(fetchedPortofolio);
            const itIsHOMii = _.get(fetchedPortofolio, 'name') === 'HOMii';
            setIsHOMii(itIsHOMii);
            if(!itIsHOMii && agentId) {
                const fetchedAgentDetails = await agentDomain.getAgentDetailsById(agentId);
                setAgentDetails(fetchedAgentDetails);
            }
        };            
        search();
    }, [portfolioId, selectedRoomType, agentId]);

    const gridItemClass = isTablet ? 'main-grid-item main-grid-sm-12 main-grid-xs-12' : 'main-grid-item main-grid-sm-8 main-grid-xs-12';

    return (
        <>
            <div className='container-root container-root-maxWidthLg'>

                <RoomTypeHeader 
                    selectedRoomType={selectedRoomType}
                    selectedRoomPortfolio={selectedRoomPortfolio}
                    cities={cities}
                    buildings={buildings}
                />

                {isMobile ? <MediaGalleryMobile allImages={roomImages} /> : <MediaGallery allImages={roomImages} />}

                <div className='main-grid-container'>

                    <div className={gridItemClass}>
                        <div className='room-type-details-container'>
                            <RoomTypeDescription selectedRoomType={selectedRoomType}
                                buildingName={_.get(selectedRoomType, 'buildingName')} 
                                renderTimeToConnectForm={noRates && isMobile} 
                                roomTypeDescription={_.get(selectedRoomType, 'category')} />                            
                            <RoomTypeAmenities selectedRoomType={selectedRoomType} roomContentCMS={roomContentCMS} />
                            <RoomTypeVideoTour selectedRoomType={selectedRoomType} />
                            <RoomTypeFloorPlan selectedRoomType={selectedRoomType} />
                            <RoomTypeLocation selectedRoomType={selectedRoomType} roomContentCMS={roomContentCMS} />
                            <RoomTypeReviews selectedRoomType={selectedRoomType} roomContentCMS={roomContentCMS} />
                            {isHOMii && <RoomTypeBuildingAmenities selectedRoomType={selectedRoomType} roomContentCMS={roomContentCMS} />}
                            {selectedRoomPortfolio && <RoomTypePortfolio selectedRoomPortfolio={selectedRoomPortfolio} />}
                        </div>
                    </div>

                    <div className='main-grid-item main-grid-sm-4 main-grid-xs-12'>
                        { !noRates && isMobile && <RoomTypeQuote peachRedirect={peachRedirect} selectedRoomType={selectedRoomType} /> }
                        { !noRates && !isMobile && <RoomTypeQuote peachRedirect={peachRedirect} selectedRoomType={selectedRoomType} /> }
                        { noRates && !isMobile && <LeadGenRequestCallBackForm buildingName={ _.get(selectedRoomType, 'buildingName')} roomTypeDescription={_.get(selectedRoomType, 'category')} /> }
                    </div>

                </div>

                {!isHOMii && agentDetails && <RoomTypeAgent selectedRoomType={selectedRoomType} agentDetails={agentDetails} />}

                {isHOMii && <RoomTypeAboutBuilding selectedRoomType={selectedRoomType} buildings={buildings} />}

            </div>
            
            <LazyFeaturedSpaces
                type="featured_building"
                id="other-spaces-building"
                visibleRooms={3}
                city={selectedCity}
                text="Other Spaces"
                selectedCity={selectedCity}
                selectedBuilding={selectedBuilding}
            />            

            {isMobile && <hr className='room-type-details-divider' />}
           
            <LazyFeaturedSpaces
                type="featured_similar_spaces"
                id="similar-spaces-city"
                visibleRooms={3}
                city={selectedCity}
                selectedCity={selectedCity}
                selectedBuilding={selectedBuilding}
                selectedRoomType={selectedRoomType}
            />
            
        </>
    );
};

export default RoomTypeDetails;

RoomTypeDetails.propTypes = {
    selectedRoomType: PropTypes.object,
    cities: PropTypes.object,
    buildings: PropTypes.array,
    peachRedirect: PropTypes.bool,
    roomContentCMS: PropTypes.object,
    selectedBuilding: PropTypes.object,

};


